<template>
  <div>
    <section class="masthead masthead--inner">
      <div class="in">
        <div class="masthead__slide" style="background: rgba(0, 0, 0, 0) url(&quot;../../../../../../static/styles/mailkit/img/banner.jpg&quot;) no-repeat scroll center center / cover; width: 100%; display: inline-block;">
          <div class="masthead__caption">
            <h3>Congratulations!<br>A member of our support team will be in contact within 1 hour to arrange the necessary paperwork</h3>
          </div>
        </div>
      </div>
    </section>
    <h1>Did you know we can also support you with various other solutions? Please select any of the options below for further support.</h1>
    <section class="helpIcons">
      <div class="in container">
          <div class="helpIcons__wrap">
              <div class="helpIcons__main">
                  <div class="in">
                      <a href="https://themailingexpert.com/helpdesk/#mailandfranking">
                          <img src="https://themailingexpert.com/wp-content/themes/ctmk/assets/img/letterbig.png">
                          <h4>MAIL &amp; FRANKING</h4>
                      </a>
                  </div>
              </div>
              <div class="helpIcons__blocks">
                  <div class="ctaBlocks__block">
                      <div class="in">
                          <a href="https://themailingexpert.com/helpdesk/#xray">
                              <img src="https://themailingexpert.com/wp-content/uploads/2018/07/XRAY-1.png">
                              <h4>X RAY</h4>
                          </a>
                      </div>
                  </div>
                  <div class="ctaBlocks__block">
                      <div class="in">
                          <a href="https://themailingexpert.com/helpdesk/#letteropeners">
                              <img src="https://themailingexpert.com/wp-content/uploads/2018/07/letter-openers.png">
                              <h4>LETTER OPENERS</h4>
                          </a>
                      </div>
                  </div>
                  <div class="ctaBlocks__block">
                      <div class="in">
                          <a href="https://themailingexpert.com/helpdesk/#insertingmachines">
                              <img src="https://themailingexpert.com/wp-content/uploads/2018/07/inserting-machines.png">
                              <h4>INSERTING MACHINES</h4>
                          </a>
                      </div>
                  </div>
                  <div class="ctaBlocks__block">
                      <div class="in">
                          <a href="https://themailingexpert.com/helpdesk/#mfdandprint">
                              <img src="https://themailingexpert.com/wp-content/uploads/2018/07/mdf-print.png">
                              <h4>MFD &amp; PRINT DEVICES</h4>
                          </a>
                      </div>
                  </div>
                  <div class="ctaBlocks__block">
                      <div class="in">
                          <a href="https://themailingexpert.com/helpdesk/#hybridmail">
                              <img src="https://themailingexpert.com/wp-content/uploads/2018/07/hydbrid-mail.png">
                              <h4>HYBRID MAIL SOLUTIONS</h4>
                          </a>
                      </div>
                  </div>
                  <div class="ctaBlocks__block">
                      <div class="in">
                          <a href="https://themailingexpert.com/helpdesk/#digitisationandscan">
                              <img src="https://themailingexpert.com/wp-content/uploads/2018/07/scanning.png">
                              <h4>SCANNING SOLUTIONS</h4>
                          </a>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  mounted () {
    this.scrollTop()
  },
  methods: {
    scrollTop () {
      window.scrollTo(0, 0)
    }
  },
  computed: {}
}
</script>
<style scoped lang="scss">
  .masthead--inner {
    margin-bottom: 40px;
  }

  h1 {
    margin: 0 auto;
    padding: 0 30px;
    max-width: 800px;
    text-align: center;
    font-size: 1.8rem;
    margin-bottom: 20px;
    line-height: 1.2em;
    color: #0a70e3;
  }

</style>



// WEBPACK FOOTER //
// src/views/Order/Success.vue